import React from "react";
import styles from "~/components/productItem/ProductItem.module.scss";
import ProductItem from "~/components/productItem/ProductItem";
import { SkeletonLoaderWrapper } from "~/components/skeletons/SkeletonLoaderWrapper";
import { serviceIsLoading } from "rylak-common";
import { getActualProductId } from "~/cores/productCore";

export default function SimilarProducts(props) {
    const { similarProductServiceData, productExchangeServiceData, swapToProduct, setSwapToProduct, appProps } = props;
    const { getLocaleText } = appProps;
    const serviceIsLoadingSimilarProducts = serviceIsLoading(similarProductServiceData);
    const serviceIsLoadingExchanges = serviceIsLoading(productExchangeServiceData);

    const similarProducts = similarProductServiceData?.data?.similarProducts;
    // let filteredSimilarProducts = similarProducts?.filter((p) => swapToProduct?.actualProductId !== p.actualProductId);
    let filteredSimilarProducts = similarProducts;

    // let propertyMap = exchangeSimilarProduct ? parsePropertyMap(exchangeSimilarProduct?.variants, exchangeSimilarProduct) : parsePropertyMap(exchangeAlternatives, product);

    return (
        <SkeletonLoaderWrapper loading={serviceIsLoadingSimilarProducts && !serviceIsLoadingExchanges} loadingMinHeight={"150px"} border={true} style={{ marginTop: "10px" }}>
            <div
                style={{
                    // marginTop: Object.keys(propertyMap).length > 0 && "20px",
                    position: "relative",
                }}
            >
                {filteredSimilarProducts?.length > 0 || swapToProduct ? (
                    <>
                        {/*<h2 className={styles["swap-it-header"]}>{getLocaleText(["product-recommendation", "TITLE"])}</h2>*/}
                        <p style={{ fontSize: "12px" }} className={styles["swap-it-text"]}>
                            {getLocaleText("product-recommendation")}
                        </p>
                        {/*{exchangeSimilarProduct == null && noPropertiesAvailableError && setExchangeSimilarProduct(similarProducts[0])}*/}
                        <div
                            style={{
                                maxHeight: "230px",
                                overflow: "scroll",
                                padding: 1,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    gap: "10px",
                                    flexDirection: "column",
                                }}
                            >
                                {filteredSimilarProducts.map((similarProduct) => {
                                    const isSelected = similarProduct.actualProductId === swapToProduct?.actualProductId;
                                    return (
                                        <ProductItem
                                            {...props}
                                            key={getActualProductId(similarProduct)}
                                            selectedProductValues={null}
                                            product={similarProduct}
                                            smallImage={true}
                                            onClose={isSelected && (() => setSwapToProduct(null))}
                                            // className={styles["product-item"]}
                                            tight={true}
                                            onClick={() => {
                                                if (isSelected) {
                                                    setSwapToProduct(null);
                                                } else {
                                                    setSwapToProduct(similarProduct);
                                                }
                                            }}
                                        ></ProductItem>
                                    );
                                })}
                                {/*{swapToProduct && (*/}
                                {/*    <ProductItem*/}
                                {/*        {...props}*/}
                                {/*        selectedProductValues={null}*/}
                                {/*        product={product}*/}
                                {/*        smallImage={true}*/}
                                {/*        topRightText={"Purchased item"}*/}
                                {/*        // className={styles["product-item"]}*/}
                                {/*        tight={true}*/}
                                {/*        onClick={() => {*/}
                                {/*            setSwapToProduct(null);*/}
                                {/*        }}*/}
                                {/*    ></ProductItem>*/}
                                {/*)}*/}
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
        </SkeletonLoaderWrapper>
    );
}
